import AppNotificationSettingsTab from './app-notification-settings';

export default AppNotificationSettingsTab;
